import { useViewTableData, skeletonFactory } from 'shared';
import { operators } from 'services';

const operatorsDummy = skeletonFactory.operators();

export function useOperatorsPaginated() {
  const {
    data: operatorsData,
    get: getOperators,
    deleteElements: deleteOperators,
    errorInfo: getDeleteErrorKey,
    setErrorInfo
  } = useViewTableData({
    service: operators,
    paginatedSkeleton: operatorsDummy
  });

  return {
    operators: operatorsData,
    errorInfo: getDeleteErrorKey,
    setErrorInfo,
    getOperators,
    deleteOperators
  };
}
